export default "__VITE_ASSET__h3Wio4xH__"